<template>
  <div
    :class="
      twMerge('tw:flex tw:max-w-150 tw:flex-wrap tw:gap-y-2', props.class)
    "
  >
    <BaseCheckbox
      v-for="source in availableMedia"
      :key="source.field"
      v-model="localStream[source.property]"
      :class="twMerge('tw:min-w-24', checkboxClass)"
      :color="source.field"
      :data-testid="`checkbox-${source.field}`"
      :dense="dense"
      :disabled="disabled"
      :label="source.label"
      new-design
      @update:model-value="checkboxToggled(source.label, $event)"
    />
  </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { computed, ref, watch } from "vue";

import BaseCheckbox from "shared/components/core/forms/BaseCheckbox.vue";
import { getSources, type MediumField } from "shared/helpers/media";

export type Model = {
  [key in `${MediumField}_content`]: boolean;
};

const modelValue = defineModel<Model>();

export interface MediumSelectorProps {
  checkboxClass?: string;
  class?: string;
  dense?: boolean;
  disabled?: boolean;
  excludedMedia?: MediumField[];
}

const props = withDefaults(defineProps<MediumSelectorProps>(), {
  checkboxClass: "",
  class: undefined,
  excludedMedia: () => [],
});

const emit = defineEmits(["checkbox-toggled", "update:modelValue"]);

const sources = getSources()
  .filter(({ filterEnabled }) => filterEnabled)
  .map(({ field, label, color }) => ({
    field,
    label,
    color,
    property: `${field}_content`,
  }));

const localStream = ref(JSON.parse(JSON.stringify(modelValue.value)));

const availableMedia = computed(() =>
  sources.filter(({ field }) => !props.excludedMedia.includes(field))
);

function checkboxToggled(medium: string, value: boolean) {
  emit("checkbox-toggled", { medium, value });
  emit("update:modelValue", localStream.value);
}

watch(modelValue, () => {
  localStream.value = JSON.parse(JSON.stringify(modelValue.value));
});
</script>
